module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17apBGT/tc-custom/9781944728304.jpg?1701350716079",
      "alt": "This image is the cover for the book Soul of the Unborn, The Auras of Night Novels"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Soul of the Unborn, The Auras of Night Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("One woman battles her own dark secrets—and the pull of her heart—in an award-winning supernatural thriller set in a mystical Russian village.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Posing as a folklore tour guide, Valya Svetlova takes a group of American college students and their professor, Chris Waller, to her summer home in the Russian village of Vishenky for a few nights of supernatural phenomena. She plays the perfect hostess, for Valya doesn’t want anyone to discover she harbors selfish motives when it comes to one participant—the only person who can refute a tale declaring her a stillborn resurrected by a paranormal entity. "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Her nascent feelings toward the handsome professor inhibit her ability to control the supernatural manifestations and her inquisitive guests. When her unforeseen affection turns Chris into a target, Valya faces an excruciating reality. It’s no longer in her human power to ensure her guests’ safety. Yet to keep them alive, Valya must brush off her humanity and become the thing she fights so desperately to prove she is not—a soulless monster."), _c('br'), _c('br'), _c('b', [_vm._v("First Place in Fantasy, Science Fiction, and Horror in the Paul Gillette Writing Contest")]), _c('br'), _vm._v(" "), _c('br'), _c('b', [_vm._v("Best Speculative Fiction in American Icon 4 Contest")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Natalia Brothers\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    City Owl Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0